export function getText(payment) {
  return `with bank account${payment.last_four_digits ? ` XXXX ${payment.last_four_digits}` : ''}${payment.payer_name ? ` (${payment.payer_name})` : ''}`
}
